<template>
  <details class="simple" open>
    <summary>Top 25 Módulos</summary>
    <GChart type="ColumnChart" :data="chartData" :options="chartOptions" v-if="items.length" />
    <b-alert v-else variant="info" show> No hay datos suficientes para mostrar la gráfica. </b-alert>
  </details>
</template>
<script>
import { GChart } from "vue-google-charts/legacy";

export default {
  components: {
    GChart,
  },
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    chartData() {
      const table = [["Modulo", "Recuento Ventas"]];
      this.items.forEach((item) => {
        table.push([item.modulo, item.recuentoGanadas]);
      });
      table.sort((a, b) => b[1] - a[1]);
      return table;
    },
  },
  data() {
    return {
      chartOptions: {
        title: "Top 25 Módulos por Ventas Ganadas",
        height: 600,
        legend: { position: "none" },
        hAxis: {
          title: "Módulo",
        },
        vAxis: {
          title: "Recuento de Ventas Ganadas",
        },
        chartArea: {
          left: 150,
          top: 50,
          bottom: 250,
        },
      },
    };
  },
};
</script>
